module.exports = "### History\n\nCan't know where you're going until you know where you've been\n\n- JS fatigue, new libraries\n\n- Understand history of React\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/notes_1.md
// module id = 1482
// module chunks = 0